import { render, staticRenderFns } from "./ArrowUpRight.vue?vue&type=template&id=1a169e49&"
import script from "./ArrowUpRight.vue?vue&type=script&lang=js&"
export * from "./ArrowUpRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports